<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Customer Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label>Name</label>
                <input type="text" class="form-control" v-model="cust.name" id="name" aria-describedby="action">
            </div>
            
            <div class="form-group col-3">
                <label for="module">Email</label>
                <input type="text" class="form-control" v-model="cust.email" id="email" aria-describedby="module">
            </div>
            <div class="form-group col-3">
                <label>Phone Number</label>
                <input type="text" class="form-control" v-model="cust.phone" id="phone" aria-describedby="module">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label>Address</label>
                <textarea class="form-control" id="desc-textarea" v-model="cust.address" rows="3"></textarea>
            </div>
        </div>

        <!-- <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="cust.mailManagementDetail"></app-datatable> -->
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { Customer } from '../../models/customer'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            cust: {
                ...Customer
            }
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const custApi = api('Customer/detail')

            const custResult = await custApi.getWithParams(this.$route.query.id)
            this.cust = custResult
        }
    },
    methods: {
        async save() {
            const custApi = api('Customer')
            if(this.$route.query.id !== undefined) {
                await custApi.update(this.cust, this.$route.query.id)
            } else {
                await custApi.create(this.cust)
            }
            this.$router.push({ name: 'customer' })
        },
        cancel() {
            this.$router.push({ name: 'customer' })
        },
        finishLookup(data) {
            const currentCust = this.cust
            this.customer = {
                ...currentCust,
                ...data
            }
        },
        selectChange(data) {
            const currentData = this.cust
            this.cust = {
                ...currentData,
                ...data
            }
        },
    }
}
</script>